export default "__VITE_ASSET__BfQhzSBs__"